import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericResponse } from '@interfaces';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilValidatorsService } from 'src/app/commons/validations-format/util-validators.service';
import { UtilService } from 'src/app/services/util.service';
import { ImpersonalizeUser } from './models/impersonalize-user.model';
import { ImpersonalizeUserService } from './services/impersonalize-user-service.service';

@Component({
  selector: 'app-impersonalize-user',
  templateUrl: './impersonalize-user.component.html',
  styleUrls: ['./impersonalize-user.component.scss']
})
export class ImpersonalizeUserComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<boolean>();
  public impersonalizeForm = new FormGroup({
    email: new FormControl(
      null,
      [Validators.required, Validators.pattern(this.utilValidatorsService.emailPattern), Validators.maxLength(50), this.duplicateEmail()]
      ),
  });
  public token: string;
  public isLoading = false;
  private currentEmail: string;

  constructor(
    public dialogRef: MatDialogRef<ImpersonalizeUserComponent>,
    private authStorage: OAuthStorage,
    private impersonalizeUserService: ImpersonalizeUserService,
    private utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public data: { email: string },
    private utilValidatorsService: UtilValidatorsService
  ) { }

  ngOnInit(): void {
    this.token = this.authStorage.getItem('authorization_imp_token');
    this.impersonalizeForm.get('email').setValue(this.authStorage.getItem('email_imp'));
    this.currentEmail = this.authStorage.getItem('current_email');
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }

  public delete(): void {
    this.authStorage.removeItem('authorization_imp_token');
    this.authStorage.removeItem('email_imp');
    this.dialogRef.close(true);
  }

  public impersonalize(): void {
    this.isLoading = true;
    this.impersonalizeUserService.getUserImpersonalized(
      { MailUserToImpersonalize: this.impersonalizeForm.get('email').value }
    ).pipe(takeUntil(this.destroyed$)).subscribe((res: GenericResponse<ImpersonalizeUser>) => {
      if (res.success) {
        this.authStorage.setItem('authorization_imp_token', res.data?.userToken);
        this.authStorage.setItem('email_imp', this.impersonalizeForm.get('email').value);
        this.dialogRef.close(true);
      } else {
        this.utilService.toastErrors(res);
      }
      this.isLoading = false;
    }, error => {
      this.utilService.toastErrors(error);
      this.isLoading = false;
    });
  }

  private duplicateEmail(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value?.toLocaleLowerCase() === this.currentEmail) {
        return { duplicate_email: true };
      }
      return null;
    };
  }

}
